import { SVGProps } from 'react';

export const SvgProfile = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    viewBox="0 0 16 16"
    fill="none"
    {...props}
  >
    <path
      d="M7.99971 8.66667C9.84066 8.66667 11.333 7.17428 11.333 5.33333C11.333 3.49238 9.84066 2 7.99971 2C6.15877 2 4.66638 3.49238 4.66638 5.33333C4.66638 7.17428 6.15877 8.66667 7.99971 8.66667ZM7.99971 8.66667C9.4142 8.66667 10.7708 9.22857 11.771 10.2288C12.7711 11.229 13.333 12.5855 13.333 14M7.99971 8.66667C6.58523 8.66667 5.22867 9.22857 4.22848 10.2288C3.22828 11.229 2.66638 12.5855 2.66638 14"
      stroke="currentColor"
      strokeWidth={1.2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
